import { useState } from 'react';
import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    Col,
    Row,
} from 'reactstrap';

import DocumentDetail from './DocumentDetail';
import DocumentsList from './DocumentsList';

const DocumentForensics = ({
    bid,
    t,
}) => {
    const documents = bid.documentForensics || [];
    const [filter, setFilter] = useState('all');
    const [selectedDocumentId, setSelectedDocumentId] = useState(documents[0]?.id);
    const visibleDocuments = filter === 'all'
        ? documents
        : documents.filter((document) => document.outcome === filter);
    const selectedDocument = visibleDocuments.find((document) => document.id === selectedDocumentId)
        || visibleDocuments[0];

    if (!documents.length) {
        return (
            <Card>
                <CardBody>
                    <div className="alert m-0" role="alert">
                        <p className="text-center mb-0">{t('This section is empty')}</p>
                    </div>
                </CardBody>
            </Card>
        );
    }

    return (
        <Row className="document-forensics">
            <Col lg="3">
                <Card>
                    <CardBody>
                        <DocumentsList
                            documents={documents}
                            filter={filter}
                            onFilterChange={setFilter}
                            onSelect={setSelectedDocumentId}
                            selectedDocumentId={selectedDocument?.id}
                        />
                    </CardBody>
                </Card>
            </Col>

            <Col lg="9">
                <Card>
                    <CardBody>
                        {selectedDocument ? (
                            <DocumentDetail document={selectedDocument} />
                        ) : (
                            <p className="text-muted text-center mb-0">{t('No documents found.')}</p>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </Row>
    );
};

export default withNamespaces()(DocumentForensics);
